// extracted by mini-css-extract-plugin
export default {"job-messenger":"styles_job-messenger__GZvPD","jobMessenger":"styles_job-messenger__GZvPD"};